import { render } from "./RaffleWinners.vue?vue&type=template&id=2ac56141&scoped=true"
import script from "./RaffleWinners.vue?vue&type=script&lang=js"
export * from "./RaffleWinners.vue?vue&type=script&lang=js"

import "./RaffleWinners.vue?vue&type=style&index=0&id=2ac56141&scoped=true&lang=css"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac56141"]])

export default __exports__